import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import pathState from "../../../atoms/pathstate";
import IsoToDateTime, { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { getFields } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import "./BookingPage.scss";

const AllData = gql`
  query {
    TripBookingsCountByStage {
      AllLoads
      TripBookingConfirmed
      VehicleReachedAtLoadingPoint
      LoadingCompleted
      AdvanceProcessed
      VehicleReachedAtUnloadingPoint
      UnloadingCompleted
      ClearDeliveryConfirmation
      PODCollectionFromSP
      PODCollectionFromLP
    }
  }
`;

const BookingPage = () => {
  const [selectedCate, setSelectedCate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const { pushKey, popKey, getTopKey } = useModalContext();
  const [{ currentPath, previousPath, PerviousTitle, CurrentTitle }, setPaths] = useRecoilState(pathState);
  const Key = "Booking_Page";
  const [fetchAllLoad, { loading: queryLoading, error, data }] = useLazyQuery(
    gql`
      query AllTripBookingsAccepted($Current_Stage: String) {
        AllTripBookingsAccepted(Current_Stage: $Current_Stage) {
          _id
        }
      }
    `,
    {
      variables: { Current_Stage: selectedCate },
      fetchPolicy: "network-only",
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
    }
  );
  const { data: BookingCount } = useQuery(AllData, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [formdata, setformdata] = useState(data ? data.GetLoadsOnRequestedData : []);
  const [Workaround, setWorkAround] = useState(false);
  const rights = useSelector((state) => state.userRightsReducer.userRightsData);
  const path = window.location.pathname;
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const FieldWiseData = useSelector((store) => store?.ColumnManagementReducer?.tableData);
  const [loadingState, setLoading] = useState(true);
  const [countBookings, setCountBookings] = useState({});
  const [statusTab, setStatus] = useState([
    { name: `All` },
    { name: "Booking Confirmed" },
    { name: "Vehicle Reached At Loading Point" },
    { name: "Loading Completed" },
    { name: "Advance Processed" },
    { name: "Vehicle Reach At Unloading Point" },
    { name: "Unloading Completed" },
    { name: "Clear Delivery Confirmation" },
    { name: "POD Collected from SP" },
    { name: "Completed" },
  ]);

  let Refetch = useSelector((store) => store.FormFieldData.refresh);
  const [getCurrentField, { data: fieldData }] = useLazyQuery(getFields, {
    fetchPolicy: "network-only",
  });
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (error) {
  //     ErrorToast(error.message);
  //   }
  // }, [error]);

  const handleVisitSIM = (Sim_Tracking_Link) => {
    window.open(Sim_Tracking_Link, "_blank");
  };

  useEffect(() => {
    if (currentPath !== previousPath) {
      popKey();
      pushKey(Key);
    }
  }, [currentPath, previousPath]);

  useEffect(() => {
    if (BookingCount) {
      setCountBookings(BookingCount?.TripBookingsCountByStage);
    }
  }, [BookingCount]);
  // let statusTab
  useEffect(() => {
    if (countBookings) {
      setStatus([
        { name: `All_(${countBookings?.AllLoads})` },
        { name: `Booking_Confirmed_(${countBookings?.TripBookingConfirmed})` },
        {
          name: `Vehicle_Reached_At_Loading_Point_(${countBookings?.VehicleReachedAtLoadingPoint})`,
        },
        { name: `Loading_Completed_(${countBookings?.LoadingCompleted})` },
        { name: `Advance_Processed_(${countBookings?.AdvanceProcessed})` },
        {
          name: `Vehicle_Reach_At_Unloading_Point_(${countBookings?.VehicleReachedAtUnloadingPoint})`,
        },
        { name: `Unloading_Completed_(${countBookings?.UnloadingCompleted})` },
        {
          name: `Clear_Delivery_Confirmation_(${countBookings?.ClearDeliveryConfirmation})`,
        },
        {
          name: `POD_Collected_from_SP_(${countBookings?.PODCollectionFromSP})`,
        },
        { name: `Completed_(${countBookings?.PODCollectionFromLP})` },
      ]);
    }
  }, [countBookings]);

  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "All Load" } });
  }, []);

  useEffect(() => {
    if (Tab === `All_(${countBookings?.AllLoads})`) {
      setSelectedCate("");
    } else if (Tab === `Booking_Confirmed_(${countBookings?.TripBookingConfirmed})`) {
      setSelectedCate("Booking Confirmed");
    } else if (Tab === `Vehicle_Reached_At_Loading_Point_(${countBookings?.VehicleReachedAtLoadingPoint})`) {
      setSelectedCate("Vehicle Reached At Loading Point");
    } else if (Tab === `Loading_Completed_(${countBookings?.LoadingCompleted})`) {
      setSelectedCate("Loading Completed");
    } else if (Tab === `Advance_Processed_(${countBookings?.AdvanceProcessed})`) {
      setSelectedCate("Advance Processed");
    } else if (Tab === `Vehicle_Reach_At_Unloading_Point_(${countBookings?.VehicleReachedAtUnloadingPoint})`) {
      setSelectedCate("Vehicle Reach At Unloading Point");
    } else if (Tab === `Unloading_Completed_(${countBookings?.UnloadingCompleted})`) {
      setSelectedCate("Unloading Completed");
    } else if (Tab === `Clear_Delivery_Confirmation_(${countBookings?.ClearDeliveryConfirmation})`) {
      setSelectedCate("Clear Delivery Confirmation");
    } else if (Tab === `POD_Collected_from_SP_(${countBookings?.PODCollectionFromSP})`) {
      setSelectedCate("POD Collected From SP");
    } else if (Tab === `Completed_(${countBookings?.PODCollectionFromLP})`) {
      setSelectedCate("POD Submitted To LP");
    }
  }, [Tab]);

  useEffect(() => {
    if (fieldData) {
      const fields = fieldData.GetUserTableColumnManagementWithUserId_Page_ID.filter((item) => item.Status).map(
        (item) => item.Field_Name
      );
      if (fields.length > 0) {
        const constructedQuery = gql`
          query AllTripBookingsAccepted($Current_Stage:String){
            AllTripBookingsAccepted(Current_Stage:$Current_Stage) {
              ${fields.join(" ")}
            }
          }
        `;
        fetchAllLoad({
          query: constructedQuery,
          fetchPolicy: "network-only",
          context: {
            headers: { "X-GraphQL-Server": "secondary" },
          },
          variables: { Current_Stage: selectedCate },
        });
      }
    }
  }, [fieldData, fetchAllLoad, Workaround]);

  useEffect(() => {
    let updatedData = data?.AllTripBookingsAccepted?.map((el) => {
      let obj = { ...el };
      delete obj.__typename;
      if (obj?.Date) {
        obj.Date = IsoToDateWithoutTime(obj?.Date);
      }
      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      if (obj?.Reporting_Time) {
        obj.Reporting_Time = IsoToDateWithoutTime(obj?.Reporting_Time);
      }
      if (obj?.Booking_Date) {
        obj.Booking_Date = IsoToDateWithoutTime(obj?.Booking_Date);
      }
      if (el.Sim_Tracking_Link) {
        obj.Sim_Track = (
          <a
            href="#"
            style={{ color: "blue", textDecoration: "none" }}
            onClick={() => handleVisitSIM(el.Sim_Tracking_Link)}
          >
            Sim Track
          </a>
        );
      }
      delete obj.Sim_Tracking_Link;
      return obj;
    });
    setformdata(updatedData);
    setLoading(false);
  }, [data]);

  useEffect(() => {
    if (Refetch || !FieldWiseData[path]?.length) {
      setLoading(true);
      if (rights[path]?.Page_Id) {
        getCurrentField({
          variables: { Table_Key: Key },
        }).then((res) => {
          setWorkAround(!Workaround);
        });
      }

      dispatch({ type: "Refetch", payload: false });
    } else if (FieldWiseData[path]?.length > 0) {
      setformdata(FieldWiseData[path]);
    }
    setLoading(false);
  }, [Refetch, FieldWiseData, rights, path, getCurrentField, dispatch, selectedCate]);
  return (
    <div className="BookingContainer">
      <div className="HeaderDiv">
        <div>
          <p className="pageTitle">Booking Page</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div>
      <Tabs tabs={statusTab} />
      <HeaderDiv title={""} />
      {queryLoading && <div className="loader-line-div" />}
      <LoadTable title={Tab} data={formdata} loading={isLoading} error={error} />
    </div>
  );
};

export default BookingPage;
